import { render, staticRenderFns } from "./TogetherAccount.vue?vue&type=template&id=44e287dc&scoped=true"
import script from "./TogetherAccount.vue?vue&type=script&lang=js"
export * from "./TogetherAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e287dc",
  null
  
)

export default component.exports